import React, { Component } from "react";
import { Box } from "@mui/material";

export class Appearance extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <Box className="appearance-container">Appearance</Box>;
  }
}
export default Appearance;
